<script>
	import { replace, setResumable } from "../.";

	replace("/");

	setResumable(false);
</script>

I'm temporary... just wait a sec...
